import React from 'react';
import { ChefAvailabilityContext } from './ChefAvailabilityContext';
import BigCalendar, {
  formatDayOfWeek,
  formatTimeGutter
} from '../shared/BigCalendar';
import ChefAvailabilityEvent from './ChefAvailabilityEvent';
import ChefAvailabilityEventWrapper from './ChefAvailabilityEventWrapper';
import timeZoneOffset from '../../helpers/timeZoneOffset';

class ChefAvailabilityCalendar extends React.Component {
  agendaStartHour = new Date();
  agendaEndHour = new Date();

  components = {
    event: ChefAvailabilityEvent,
    eventWrapper: ChefAvailabilityEventWrapper
  };

  formats = {
    timeGutterFormat: formatTimeGutter,
    dayFormat: formatDayOfWeek
  };

  render() {
    const {
      selectable = true,
      onSelectSlot = () => {},
      onSelectEvent = () => {},
      className = 'chef-availability-calendar'
    } = this.props;
    return (
      <ChefAvailabilityContext.Consumer>
        {({ availabilities }) => (
          <BigCalendar
            events={availabilities}
            className={className}
            components={this.components}
            selectable={selectable}
            toolbar={false}
            min={this.agendaStartHour}
            max={this.agendaEndHour}
            formats={this.formats}
            onNavigate={() => {}}
            onView={() => {}}
            onSelectSlot={onSelectSlot}
            onSelectEvent={onSelectEvent}
            defaultView="week"
            views={['week']}
          />
        )}
      </ChefAvailabilityContext.Consumer>
    );
  }

  componentDidMount() {
    this.agendaStartHour.setHours(timeZoneOffset().open, 0, 0, 0);
    this.agendaEndHour.setHours(timeZoneOffset().close, 0, 0, 0);
  }
}
export default ChefAvailabilityCalendar;



// WEBPACK FOOTER //
// ./src/components/chef/ChefAvailabilityCalendar.js